import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  generalLedgerDownloadApi,
  getAgeingAnalysisReportApi,
  getBalanceSheetApi,
  getBatchSummaryReportApi,
  getBatchVoucherReportApi,
  getCostOfGoodsApi,
  getDayBookReportsApi,
  getDetailedBalanceSheetApi,
  getDetailedNatureOfIncomeExpenseApi,
  getDetailedProfitLossStatementApi,
  getDetailedTrialBalanceApi,
  getGeneralLedgerReportsApi,
  getIncomeExpenseProfitApi,
  getLedgerStatementApi,
  getMonthlyLedgerSummaryApi,
  getProfitLossStatementApi,
  getReceiptAndPaymentReportApi,
  getSaleseExpensePerformanceApi,
  getIncomeExpenseLedgerApi,
  getStockLimitApi,
  getStockReportsSummaryApi,
  getStockStatementApi,
  getTrialBalanceApi,
  emailOCRComparisonReportApi,
  getRelatedPartyTransactionReportApi,
} from "@/apis/reportsApis";

import type {
  BatchSummaryReportPayloadType,
  BatchVoucherReportPayloadType,
  GeneralLedgerDownloadPayloadType,
  GetBalanceSheetPayloadType,
  GetCostOfGoodsPayloadType,
  GetDayBookReportsPayloadType,
  GetDetailedBalanceSheetPayloadType,
  GetGeneralLedgerPayloadType,
  GetLedgerStatementType,
  GetMonthlyLedgerSummaryType,
  GetProfitLossStatementPayloadType,
  GetReceiptAndPaymentReportsPayloadType,
  GetSalesExpensePerformanceType,
  GetIncomeExpenseLedgerType,
  GetStockLimitPayloadType,
  GetStockReportsSummaryPayloadType,
  GetStockStatementPayloadType,
  GetTrialBalancePayloadType,
  OCRComparisonReportPayloadType,
  GetRelatedPartyReportPayloadType,
} from "@/commonTypes/reportsTypes";

export const getLedgerStatementAction = createAsyncThunk(
  "reports/getLedgerStatement",
  async (data: GetLedgerStatementType) => {
    const response = await getLedgerStatementApi(data);
    return response.data;
  }
);

export const getTrialBalanceAction = createAsyncThunk(
  "reports/getTrialBalance",
  async (data: GetTrialBalancePayloadType) => {
    const response = await getTrialBalanceApi(data);
    return response.data;
  }
);

export const getDetailedTrialBalanceAction = createAsyncThunk(
  "reports/getDetailedTrialBalance",
  async (data: GetTrialBalancePayloadType) => {
    const response = await getDetailedTrialBalanceApi(data);
    return response.data;
  }
);

export const getProfitLossStatementAction = createAsyncThunk(
  "reports/getProfitLossStatement",
  async (data: GetProfitLossStatementPayloadType) => {
    const response = await getProfitLossStatementApi(data);
    return response.data;
  }
);

export const getDetailedProfitLossStatementAction = createAsyncThunk(
  "reports/getDetailedProfitLossStatement",
  async (data: GetProfitLossStatementPayloadType) => {
    const response = await getDetailedProfitLossStatementApi(data);
    return response.data;
  }
);

export const getDetailedNatureOfIncomeExpenseAction = createAsyncThunk(
  "reports/getDetailedNatureOfIncomeExpense",
  async (data: GetProfitLossStatementPayloadType) => {
    const response = await getDetailedNatureOfIncomeExpenseApi(data);
    return response.data;
  }
);

export const getDetailedBalanceSheetAction = createAsyncThunk(
  "reports/getDetailedBalanceSheetStatement",
  async (data: GetDetailedBalanceSheetPayloadType) => {
    const response = await getDetailedBalanceSheetApi(data);
    return response.data;
  }
);

export const getBalanceSheetAction = createAsyncThunk(
  "reports/getBalanceSheet",
  async (data: GetBalanceSheetPayloadType) => {
    const response = await getBalanceSheetApi(data);
    return response.data;
  }
);

//Stock Reports
export const getStockReportsSummaryAction = createAsyncThunk(
  "reports/getStockReportsSummary",
  async (data: GetStockReportsSummaryPayloadType) => {
    const response = await getStockReportsSummaryApi(data);
    return response;
  }
);
export const getStockStatementAction = createAsyncThunk(
  "reports/getStockStatement",
  async (data: GetStockStatementPayloadType) => {
    const response = await getStockStatementApi(data);
    return response;
  }
);

// Day Book Reports
export const getDayBookReportsAction = createAsyncThunk(
  "reports/getDayBookReportsApi",
  async (data: GetDayBookReportsPayloadType) => {
    const response = await getDayBookReportsApi(data);
    return response.data;
  }
);

// General Ledger
export const getGeneralLedgerReportsAction = createAsyncThunk(
  "reports/getGeneralLedgerReportsApi",
  async (data: GetGeneralLedgerPayloadType) => {
    const response = await getGeneralLedgerReportsApi(data);
    return response.data;
  }
);

//cost of goods
export const getCostOfGoodsAction = createAsyncThunk(
  "reports/getCostOfGoodsAction",
  async (data: GetCostOfGoodsPayloadType) => {
    const response = await getCostOfGoodsApi(data);
    return response.data;
  }
);

// ageing analysis report
export const getAgeingAnalysisReportAction = createAsyncThunk(
  "reports/getAgeingAnalysisAction ",
  async (data: any) => {
    const response = await getAgeingAnalysisReportApi(data);
    return response.data;
  }
);

// receipt and payment report
export const getReceiptAndPaymentReportAction = createAsyncThunk(
  "reports/getReceiptAndPaymentReportAction ",
  async (data: GetReceiptAndPaymentReportsPayloadType) => {
    const response = await getReceiptAndPaymentReportApi(data);
    return response.data;
  }
);

export const getStockLimitAction = createAsyncThunk(
  "reports/getStockLimit",
  async (data: GetStockLimitPayloadType) => {
    const response = await getStockLimitApi(data);
    return response;
  }
);

// Batch Summary Report

export const getBatchSummaryReportAction = createAsyncThunk(
  "reports/getBatchSummaryReport",
  async (data: BatchSummaryReportPayloadType) => {
    const response = await getBatchSummaryReportApi(data);
    return response;
  }
);

// Batch Voucher Report

export const getBatchVoucherReportAction = createAsyncThunk(
  "reports/getBatchVoucherReport",
  async (data: BatchVoucherReportPayloadType) => {
    const response = await getBatchVoucherReportApi(data);
    return response;
  }
);

// Monthly Ledger Summary

export const getMonthlyLedgerSummaryAction = createAsyncThunk(
  "reports/getMonthlyLedgerSummary",
  async (data: GetMonthlyLedgerSummaryType) => {
    const response = await getMonthlyLedgerSummaryApi(data);
    return response;
  }
);

export const getGeneralLedgerDownloadHistoryAction = createAsyncThunk(
  "reports/getGeneralLedgerDownloadHistory",
  async (data: GeneralLedgerDownloadPayloadType) => {
    const response = await generalLedgerDownloadApi(data);
    return response;
  }
);
export const getIncomeExpenseProfitAction = createAsyncThunk(
  "reports/getIncomeExpenseProfitAction",
  async (data: GetReceiptAndPaymentReportsPayloadType) => {
    const response = await getIncomeExpenseProfitApi(data);
    return response;
  }
);
export const getSaleseExpensePerformanceAction = createAsyncThunk(
  "reports/getSaleseExpensePerformanceAction",
  async (data: GetSalesExpensePerformanceType) => {
    const response = await getSaleseExpensePerformanceApi(data);
    return response;
  }
);
export const getExpensePerformanceAction = createAsyncThunk(
  "reports/getExpensePerformanceAction",
  async (data: GetSalesExpensePerformanceType) => {
    const response = await getSaleseExpensePerformanceApi(data);
    return response;
  }
);

export const getIncomeExpenseLedgerAction = createAsyncThunk(
  "reports/getIncomeExpenseLedgerAction",
  async (data: GetIncomeExpenseLedgerType) => {
    const response = await getIncomeExpenseLedgerApi(data);
    return response;
  }
);

export const emailOCRComparisonReportAction = createAsyncThunk(
  "reports/emailOCRComparisonReportAction",
  async (data: OCRComparisonReportPayloadType) => {
    const response = await emailOCRComparisonReportApi(data);
    return response;
  }
);

export const getRelatedPartyTransactionReportAction = createAsyncThunk(
  "reports/getRelatedPartyReport",
  async (data: GetRelatedPartyReportPayloadType) => {
    const response = await getRelatedPartyTransactionReportApi(data);
    return response;
  }
);
